import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/authStore';
import { authAPI } from '../utils/api';
import { toast } from 'react-toastify';
import '../styles/Login.css';

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const login = useAuthStore((state) => state.login);
  const [isSignUp, setIsSignUp] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: ''
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      toast.error(t('common.fillAllFields'));
      return;
    }

    try {
      setLoading(true);

      let response;
      if (isSignUp) {
        if (!formData.name) {
          toast.error(t('common.enterName'));
          return;
        }
        if (formData.password.length < 8) {
          toast.error(t('common.passwordMinLength'));
          return;
        }
        response = await authAPI.signUp(
          formData.email,
          formData.password,
          formData.name
        );
      } else {
        response = await authAPI.login(formData.email, formData.password);
      }

      login(response.data.user, response.data.token);
      toast.success(t('common.authenticationSuccess'));
      navigate(response.data.user.role === 'admin' ? '/admin' : (location.state?.from || '/'));
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          (isSignUp ? t('common.signUpFailed') : t('common.loginFailed'))
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <h1>{isSignUp ? t('auth.signup') : t('auth.login')}</h1>

          <form onSubmit={handleSubmit}>
            {isSignUp && (
              <div className="form-group">
                <label>{t('auth.name')}</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required={isSignUp}
                />
              </div>
            )}

            <div className="form-group">
              <label>{t('auth.email')}</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>{t('auth.password')}</label>
                <input
                  type="password"
                name="password"
                value={formData.password}
                  onChange={handleInputChange}
                  minLength={isSignUp ? 8 : undefined}
                  required
                />
                {isSignUp && (
                  <small className="field-help">{t('auth.passwordHelp')}</small>
                )}
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? t('common.loading') : t('auth.getStarted')}
            </button>
            {!isSignUp && (
              <div className="forgot-password-link">
                <Link to="/forgot-password">{t('auth.forgotPassword')}</Link>
              </div>
            )}
          </form>

          <div className="auth-toggle">
            <p>
              {isSignUp ? t('auth.alreadyHaveAccount') : t('auth.dontHaveAccount')}
              {' '}
              <button
                type="button"
                className="toggle-btn"
                onClick={() => {
                  setIsSignUp(!isSignUp);
                  setFormData({ email: '', password: '', name: '' });
                }}
              >
                {isSignUp ? t('auth.login') : t('auth.signup')}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
